import VueI18n from "vue-i18n";
import Vue from "vue";
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from "@/constants/trans";

import nl from "@/lang/nl.json";
import en from "@/lang/en.json";
import de from "@/lang/de.json";
import fr from "@/lang/fr.json";
import es from "@/lang/es.json";
import se from "@/lang/se.json";
import da from "@/lang/da.json";
import it from "@/lang/it.json";

Vue.use(VueI18n);

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE,
  fallbackLocale: FALLBACK_LANGUAGE,
  messages: {
    nl,
    en,
    de,
    fr,
    es,
    se,
    da,
    it,
  },
});
